
import api from '@/plugins/request/index';

// 词根报告-列表
export const getRootReportList = async (params, type = 'get') => {
  return api[type](`/sem/v1/report/root-keyword-report`, params).then(res => res);
}
// 账户报表-列表
export const getAccountReportList = async (params, type = 'get') => {
  return api[type](`/sem/v1/report/account-report`, params).then(res => res);
}
// 渠道报表-列表
export const getChannelReportList = async (params, type = 'get') => {
  return api[type](`/sem/v1/report/channel-report`, params).then(res => res);
}
// 项目报表-列表
export const getProjectReportList = async (params, type = 'get') => {
  return api[type](`/sem/v1/report/project-report`, params).then(res => res);
}
// 计划报表-列表
export const getPlanReportList = async (params, type = 'get') => {
  return api[type](`/sem/v1/report/plan-report`, params).then(res => res);
}
// 关键词报表-列表
export const getKeywordReportList = async (params, type = 'get') => {
  return api[type](`/sem/v1/report/keyword-report`, params).then(res => res);
}
// 词根报告-Top10
export const getRootTop = async (params, type = 'get') => {
  return api[type](`/sem/v1/report/root-keyword-top-report`, params).then(res => res);
}
// 项目报告-获客Top
export const getProjectTop = async (params, type = 'get') => {
  return api[type](`/sem/v1/report/project-top-report`, params).then(res => res);
}
// 单元报告-获客Top
export const getUnitTop = async (params, type = 'get') => {
  return api[type](`/sem/v1/report/unit-top-report`, params).then(res => res);
}
// 关键词报告-成本分布
export const getkeywordCost = async (params, type = 'get') => {
  return api[type](`/sem/v1/report/keyword-cost-report`, params).then(res => res);
}
// 词根报告-导出
export const exportRootReport = '/sem/v1/report/root-keyword-export'
// 账户报告-导出
export const exportAccountReport = '/sem/v1/report/account-export'
// 渠道报告-导出
export const exportChannelReport = '/sem/v1/report/channel-export'
// 项目报告-导出
export const exportProjectReport = '/sem/v1/report/project-export'
// 计划报告-导出
export const exportPlanReport = '/sem/v1/report/plan-export'
// 单元报告-导出
export const exportUnitReport = '/sem/v1/report/unit-export'
// 关键词报告-导出
export const exportKeywordReport = '/sem/v1/report/keyword-export'
// 创意报告-导出
export const exportIdeaReport = '/sem/v1/report/idea-export'

// 获取计划列表
export const getPlanList = async (params, type = 'get') => {
  return api[type]('/sem/v1/plans-by-company', params).then(res => res);
}
// 账户报表-获客时间分布
export const accountTimeReport = async (params, type = 'get') => {
  return api[type](`/sem/v1/report/account-time-period-report`, params).then(res => res);
}
// 账户报表-获客日期分布
export const accountDateReport = async (params, type = 'get') => {
  return api[type](`/sem/v1/report/account-date-period-report`, params).then(res => res);
}
// 计划报表-获客时间分布
export const planTimeReport = async (params, type = 'get') => {
  return api[type](`/sem/v1/report/plan-time-period-report`, params).then(res => res);
}
// 计划报表-获客日期分布
export const planDateReport = async (params, type = 'get') => {
  return api[type](`/sem/v1/report/plan-date-period-report`, params).then(res => res);
}
// 创意报告-成本分布
export const getIdeaCost = async (params, type = 'get') => {
  return api[type](`/sem/v1/report/idea-cost-report`, params).then(res => res);
}
// 单元报表-列表
export const getUnitReportList = async (params, type = 'get') => {
  return api[type](`/sem/v1/report/unit-report`, params).then(res => res);
}
// 创意报表-列表
export const getIdeaReportList = async (params, type = 'get') => {
  return api[type](`/sem/v1/report/idea-report`, params).then(res => res);
}
// 渠道报告-获客日期对比
export const getChannelDateCompare = async (params, type = 'get') => {
  return api[type](`/sem/v1/report/channel-date-period-report`, params).then(res => res);
}
// 计划报告-获客Top
export const getPlanTop = async (params, type = 'get') => {
  return api[type](`/sem/v1/report/plan-top-report`, params).then(res => res);
}
// 逻辑账户公司名称搜索
export const accountSearchCompanies = async (params, type = 'get') => {
  return api[type]('/gateway/v1/report/companies-for-search', params).then(res => res);
}
// 逻辑账户列表
export const getAccountList = async (params, type = 'get') => {
  return api[type]('/sem/v1/accounts-by-company', params).then(res => res);
}
